/**
 * deployent-summary-edit.js
 */

import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import analytics from 'utils/analytics';
import { shouldRenderMobileLayout } from 'utils/app-context';
import { EditorIconSection } from 'components/icon-section/icon-section';
import HelpTextItem from 'components/menu-drawer/help-text-item';
import TextField from 'components/form-inputs/text-field';
import EditorTextTemplates from 'components/editor-text-templates';
import WeatherEdit from 'components/weather/edit';
import FilesEdit from 'components/files/edit/files-edit';

export default function DeploymentSummaryEdit(props) {
  const {
    drawerState,
    edit,
  } = props;
  const { t } = useTranslation(edit.translation);
  const { getValues, setValue } = useFormContext();

  return (
    <>
      {/* comments */}
      <EditorIconSection
        iconName='comment'
        iconMarginTop={24}
        helpProps={{
          translation: edit.translation,
          section: 'summary'
        }}
      >
        <HelpTextItem
          sidebarText={drawerState.sidebarText}
          title={t('summary.comments.helpTitle')}
          text={t('summary.comments.helpInfo')}
        >
          {focusHandlers =>
            <>
              <EditorTextTemplates
                recent={edit.options.recentCommonValues.comments}
                translation={edit.translation}
                samplesTranslationKey='summary.comments.templates'
                onSelect={value => {
                  analytics.trackGA4('event', { name: 'record_template', params: { record_type: 'deployment', template_type: 'comments' } });
                  let currValue = getValues('summary.comments');
                  currValue = currValue.replace('<Not Specified>', '');
                  const newValue = `${currValue}${currValue ? '\n\n' : ''}${value}`;
                  setValue('summary.comments', newValue, { shouldDirty: true });
                }}
              />
              <TextField
                name={`summary.comments`}
                label={t('summary.comments.label')}
                focusHandlers={focusHandlers}
                rules={{ 
                  required: t('summary.comments.errMsgEmpty'),
                  validate: value => value.trim() !== '' || t('summary.comments.errMsgEmpty'),
                }}
                multiline
                rows={shouldRenderMobileLayout() ? 15 : 10}
              />
            </>}
        </HelpTextItem>
      </EditorIconSection>


      {/* weather */}
      <WeatherEdit
        name='summary.weather'
        drawerState={drawerState}
        translation={edit.translation}
        location={edit.record.location}
        datetime={edit.record.date}
      />


      {/* files */}
       <FilesEdit
        name='summary.files'
        drawerState={drawerState}
        translation={edit.translation}
       />
    </>
  );
}